import { Provider } from "@angular/core";
import { ProjectAccountCategoryLookupService } from "./services/projectAccountCategoryLookupService.g";
import { ProjectAccountLookupService } from "./services/projectAccountLookupService.g";
import { ProjectCategoryLookupService } from "./services/projectCategoryLookupService.g";
import { ProjectGroupLookupService } from "./services/projectGroupLookupService.g";
import { ProjectPriorityLookupService } from "./services/projectPriorityLookupService.g";
import { ProjectService } from "./services/projectService.g";
import { ProjectStatusLookupService } from "./services/projectStatusLookupService.g";
import { ProjectTypeLookupService } from "./services/projectTypeLookupService.g";

export function provideProjectAccounting(): Array<Provider>
{
    return [
        ProjectTypeLookupService,
        ProjectStatusLookupService,
        ProjectPriorityLookupService,
        ProjectGroupLookupService,
        ProjectCategoryLookupService,
        ProjectAccountCategoryLookupService,
        ProjectService,
        ProjectAccountLookupService,
    ];
}
